import { gql } from "@apollo/client";

const GET_ORDERS = gql`
  query GetOrders(
    $params: QueryParams
    $client: QueryOperators
    $status: QueryOperators
    $location: QueryOperators
    $excludeStatus: QueryOperators
    $requiredInvoice: Boolean
    $existsInvoice: Boolean
    $startDate: Date
    $endDate: Date
  ) {
    orders(
      params: $params
      client: $client
      status: $status
      location: $location
      excludeStatus: $excludeStatus
      requiredInvoice: $requiredInvoice
      existsInvoice: $existsInvoice
      startDate: $startDate
      endDate: $endDate
    ) {
      info {
        count
      }
      results {
        id
        location{
          id
          name
        }
        status
        price
        updatedAt
        reference
        lineItems {
          product {
            id
            title
            img
            price
            description
            isPrimaryVariant
            product {
              id
              name
              description # Fetch nested product description
            }
          }
          qty
        }
        client {
          id
          user {
            firstName
            lastName
          }
          fiscalData {
            name
            rfc
            email
            regimenFiscal
            usoCFDI
            address {
              country
              city
              state
              street
              postcode
              colony
              internalNumber
              exteriorNumber
            }
          }
        }
        requiredInvoice
        invoice {
          id
          xml
          pdf
          status
        }
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  } 
`;

const GET_ORDER = gql`
  query GetOrder($id: ID!) {
    order(id: $id) {
      id
      status
      price
      updatedAt
      reference
      dropOffTime
      pickupTime
      lineItems {
        product {
          id
          title
          img
          price
          description
          isPrimaryVariant
          product {
            id
            name
            description # Fetch nested product description
          }
        }
        qty
      }
      events {
        type
        description
        changedAt
      }
      location {
        id
        name
        img
      }
      client {
        user {
          firstName
          lastName
        }
      }
      payment {
        id
        status
        createdAt
        paymentMethod {
          id
          last4
          brand
          type
        }
      }
    }
  }
`;

const GET_CLIENTS = gql`
  query GetClients($params: QueryParams, $search: String) {
    clients(params: $params, search: $search) {
      results {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

const GET_ORDERS_INDICATORS = gql`
  query ordersIndicators(
    $status: QueryOperators
    $excludeStatus: QueryOperators
    $client: QueryOperators
    $location: QueryOperators
    $startDate: String
    $endDate: String
  ) {
    ordersIndicators(
      status: $status
      excludeStatus: $excludeStatus
      client: $client
      location: $location
      startDate: $startDate
      endDate: $endDate
    ) {
      totalOrders
      pendingOrders
      completedOrders
      ingresos
    }
  }
`;

export { GET_ORDERS, GET_CLIENTS, GET_ORDER, GET_LOCATIONS, GET_ORDERS_INDICATORS };
